import { render, staticRenderFns } from "./UpdateSkuStock.vue?vue&type=template&id=5dfddc88"
import script from "./UpdateSkuStock.vue?vue&type=script&lang=js"
export * from "./UpdateSkuStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports